import { FileTypes } from './../enums/file-types';
import { Attachment } from "./attachment";

export class PortfolioAttachment extends Attachment {
  url: string | null;
  resumeId: string;
  filePath: string;
}

export class PreviewAttachment extends PortfolioAttachment {
  attachmentUIPath: any;
  isYoutubeVideoLink: boolean;
  isAudioLink: boolean;
  fileType: FileTypes
}
